import axios from 'axios';
import { appConfig } from '../../../tools/AppConfig';

const COUNTRY_URL = appConfig.getServerUrl();


export const getProduct = (
  productToken
  ) => {
    return axios
      .get(`${COUNTRY_URL}/product2/${productToken}`)
      .then((res) => res)
      .catch((err) => err.response);
  };

export const getProductInstallments = (
    integrationId,
    paymentToken,
    amount,
    offerId
  ) => {
    if(offerId){
      return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/paymentlink_installments?product_token=${paymentToken}`, {
        "integration_id":integrationId,
        "payment_token": paymentToken,
        "amount_cents":amount*100,
        "offer_id": offerId
      })
      .then((res) => res)
      .catch((err) => err.response);
  }
  
    else{
      return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/paymentlink_installments?product_token=${paymentToken}`, {
        "integration_id":integrationId,
        "payment_token": paymentToken,
        "amount_cents":amount*100
      })
      .then((res) => res)
      .catch((err) => err.response);
  }
    }

  export const payForsaProduct = (
    downPayment,
    phone,
    categoryId,
    planId,
    productToken,
    integrationId,
    userData,
    deliveryData,
    installmentData,
    quantity,
    deliveryNeed
  ) => {
    return axios
      .post(`${COUNTRY_URL}/product2/${productToken}`, {
          "order_data": {
              "delivery_needed": deliveryNeed,
              "amount_cents": parseInt(userData.amount)*quantity*100,
              "currency": userData.currency,
              "shipping_data": {
                  "first_name":  deliveryData.name.split(' ')[0],
                  "last_name": deliveryData.name.split(' ')[1],
                  "phone_number": deliveryData.phone,
                  "email": deliveryData.email,
                  "street": deliveryData.street || "NA",
                  "city": deliveryData.city ||"NA",
                  "country": deliveryData.country || "NA",
                  "postal_code": deliveryData.postal_code || "NA",
                  "state": deliveryData.state || "NA"
              },
              "items": [
                  {
                      "name": userData.product_name,
                      "amount_cents": parseInt(userData.amount)*quantity*100,
                      "quantity": quantity
                  }
              ],
              "data":{
                  "installment_data": installmentData
              }
          },
          "source": {
              "identifier": phone,
              "selected_plan": categoryId,
              "tenure": planId,
              "down_payment": downPayment,
              "subtype": "FORSA_ONLINE"
          },
          "token": productToken,
          "integration_id": integrationId
      })
    
      .then((res) => res)
      .catch((err) => err.response);
  };

  export const productSendOTP = (otp, token, reference) => {
    return axios
      .post(`${COUNTRY_URL}/api/acceptance/forsa_online/submit_loan`, {
        otp: otp,
        payment_token: token,
        reference: reference,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };
  
  export const productReSendOTP = (token, reference) => {
    return axios
      .post(`${COUNTRY_URL}/forsa_online/resend_otp`, {
        reference: reference,
        payment_token: token,
      })
      .then((res) => res)
      .catch((err) => err.response);
  };


